import CryptoJS from 'crypto-js';

const encryptData = (data, { key, iv }) => {
    const msg = JSON.stringify(data);
    const parsedIv = CryptoJS.enc.Utf8.parse(iv);
    const parsedKey = CryptoJS.enc.Utf8.parse(key);
    const encryptedData = CryptoJS.AES.encrypt(msg, parsedKey, {
        iv: parsedIv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });
    return encryptedData.toString();
};
const decryptData = (encryptedBase64, { key, iv }) => {
    const parsedIv = CryptoJS.enc.Utf8.parse(iv);
    const parsedKey = CryptoJS.enc.Utf8.parse(key);
    const decrypted = CryptoJS.AES.decrypt(encryptedBase64, parsedKey, {
        iv: parsedIv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });
    const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
    try {
        return JSON.parse(decryptedText);
    }
    catch (_a) {
        return decryptedText; // In case it's not JSON (e.g., just a string)
    }
};

export { decryptData, encryptData };
//# sourceMappingURL=encryptData.js.map
